<template>
  <div id="page-scenario-edit">
    {{ /* LOADER */ }}
    <loading
        :active.sync="loader.isLoading"
        :can-cancel="false"
        :is-full-page="loader.fullPage"
        :opacity="loader.opacity"
        :color="loader.color"
    ></loading>

    {{ /* Heading page */ }}
    <div class="header-pages-block d-md-flex justify-content-between">
      <div>
        <h5>
          {{ $t('pages.scenario.editScenario') }}:
          <strong>{{ ScenarioModule.scenario.name }}</strong>
        </h5>
      </div>
      <div>
        <router-link
            class="btn btn-outline-primary mb-3"
            :to="{ name: 'scenario-index' }"
        >
          {{ $t('common.back') }}
        </router-link>
      </div>
    </div>

    {{ /* Form component */ }}
    <FormCrudScenario
        :scenario="ScenarioModule.scenario"
        :papers="PaperModule.papers"
        :selected-paper="getSelectedPaper"
        :finishes="FinishingModule.finishes"
        :selected-finishing="getSelectedFinishing"
        :categories="CategoryModule.categories"
        :id="ScenarioModule.scenario.id"
        :actionForm="'edit'"
    />
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  data() {
    return {
      loader: {
        opacity: 0.9,
        isLoading: false,
        fullPage: true,
      }
    }
  },
  methods: {
    /*----------------- LOADER ------------------*/
    showLoader() {
      this.loader.isLoading = true
    },
    hideLoader() {
      this.loader.isLoading = false
    },
  },
  mounted() {
    this.showLoader()
  },
  created() {
    this.showLoader()

    if (this.ScenarioModule.scenario) {
      this.ScenarioModule.scenario = null
    }
    this.$store.dispatch('fetchScenario', this.$route.params.id)

    this.$store.dispatch('fetchCategories', {
      perPage: null,
      page: null
    })

    this.$store.dispatch('fetchPapers', {
      perPage: null,
      page: null
    })

    this.$store.dispatch('fetchFinishes', {
      perPage: null,
      page: null
    })
  },
  updated() {
    this.hideLoader()
  },
  computed: {
    getSelectedPaper() {
      return (this.ScenarioModule.scenario && this.ScenarioModule.scenario.paper) ? this.ScenarioModule.scenario.paper.id : null
    },
    getSelectedFinishing() {
      return (this.ScenarioModule.scenario && this.ScenarioModule.scenario.finishing) ? this.ScenarioModule.scenario.finishing.id : null
    },
    ...mapState(['ScenarioModule']),
    ...mapState(['PaperModule']),
    ...mapState(['FinishingModule']),
    ...mapState(['CategoryModule'])
  },
  components: {
    Loading: () => import('vue-loading-overlay'),
    FormCrudScenario: () => import('@/components/pages/scenario/FormCrudScenario')
  }
}
</script>

<style scoped>

</style>
